<form (submit)="submitForm(currentForm.form.valid)" #currentForm="ngForm" novalidate>
  <fieldset>
    <legend *ngIf="!appointmentRequestResult.id">New Result for attendee</legend>
    <legend *ngIf="appointmentRequestResult.id">Editing Result</legend>
    <div class="form-group">
      <div class="row">
        <div class="col-sm-6">
          <label>Result</label>
          <select class="form-control" required name="result" [(ngModel)]="appointmentRequestResult.result" #result="ngModel">
            <option>-</option>
            <option *ngFor="let resultString of formOptions.results" [value]="resultString">{{ resultString }}</option>
          </select>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(result)">A result has to be selected</div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-sm-6">
          <label>Attendees</label>
          <select class="form-control" name="attendee_id" [(ngModel)]="appointmentRequestResult.attendee_id" #attendee_id="ngModel" (change)="onAttendeeSelect(appointmentRequestResult.attendee_id)">
            <option>-</option>
            <option *ngFor="let attendee of attendees" [value]="attendee.value">{{ attendee.label }}</option>
          </select>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!showAttendeeRequiredError(attendee_id)">An attendee has to be selected</div>
          <small class="form-text text-muted"> Select Attendee for the result </small>
        </div>
        <div class="col-sm-6" *ngIf="appointmentRequestResult.result != 'Message From Client'">
          <label>Phone Number of attendee</label>
          <select class="form-control" name="phone_number" [(ngModel)]="appointmentRequestResult.phone_number" #phone_number="ngModel" [disabled]="!appointmentRequestResult.attendee_id">
            <option>-</option>
            <option *ngFor="let phoneNumber of phoneNumbers" [value]="phoneNumber.label">{{ phoneNumber.label }}</option>
          </select>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!showPhoneNumberRequiredError(phone_number)">A phone number has to be selected if the result is not {{ formOptions.results_phone_number_not_required_for.join(', ') }}</div>
          <small class="form-text text-muted" *ngIf="!appointmentRequestResult.attendee_id"> Select an attendee to get their phone number list </small>
          <span class="help-block text-danger" *ngIf="appointmentRequestResult.attendee_id && phoneNumbers.length < 1"> No phone numbers found for this attendee </span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Notes</label>
      <textarea class="form-control" name="notes" [(ngModel)]="appointmentRequestResult.notes" #notes="ngModel"></textarea>
    </div>
    <fieldset *ngIf="appointmentRequestResult.result == 'Schedule'">
      <div class="row">
        <div class="col-sm-2 col-md-2 col-lg-2 d-none d-sm-block"></div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 pb-3">
          <div class="card bg-light">
            <div class="card-body">
              <h4 class="card-title">Schedule Event</h4>
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-6">
                    <label>Date</label>
                    <app-datepicker (date_result)="onDateSelect($event)"></app-datepicker>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label>From</label>
                    <app-timepicker (time_result)="onTimeSelect($event, 'from')"></app-timepicker>
                  </div>
                  <div class="col-sm-6">
                    <label>To</label>
                    <app-timepicker (time_result)="onTimeSelect($event, 'to')" [initial_time]="defaultToTime()"></app-timepicker>
                  </div>
                </div>
              </div>
              <div class="form-group" *ngIf="eventType == 'Phone Conference'">
                <div class="row">
                  <div class="col-sm-12">
                    <label>Phone Number</label>
                    <select class="form-control" name="phone_number_id" [(ngModel)]="scheduleEvent.phone_number_id" #phone_number_id="ngModel" required>
                      <option>-</option>
                      <option *ngFor="let phoneNumber of eventPhoneNumbers" [value]="phoneNumber.value">{{ phoneNumber.label }}</option>
                    </select>
                    <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(phone_number_id)">A phone number has to be selected for Phone Conference event</div>
                  </div>
                </div>
              </div>
              <div class="checkbox" *ngIf="eventType == 'Phone Conference'">
                <label>
                  <input type="checkbox" [(ngModel)]="scheduleEvent.initiates_phone_call" name="initiates_phone_call" #initiates_phone_call="ngModel" />
                  Initiate Phone Call
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
    <div class="form-group has-error" *ngIf="!currentForm.form.valid && formSubmitted" style="border-top: 1px solid #ccc">
      <span class="help-block"> Some errors were found in the form, please check again. </span>
    </div>
    <div class="form-group text-center">
      <button type="submit" class="btn btn-primary" [disabled]="formSubmitting">{{ appointmentRequestResult.id ? 'Update' : 'Create' }}</button>
      &nbsp;&nbsp;&nbsp;
      <button type="button" class="btn btn-secondary" [disabled]="formSubmitting" (click)="this.formSaved.emit('FormCancelled')">Cancel</button>
    </div>
  </fieldset>
</form>
